import { render, staticRenderFns } from "./PostcodecheckerV5.vue?vue&type=template&id=bba6408e&scoped=true"
import script from "./PostcodecheckerV5.vue?vue&type=script&lang=js"
export * from "./PostcodecheckerV5.vue?vue&type=script&lang=js"
import style0 from "./PostcodecheckerV5.vue?vue&type=style&index=0&id=bba6408e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba6408e",
  null
  
)

export default component.exports